import { useState } from 'react';
import { useRunOnce } from '../../../common/useRunOnce';

interface ImageWithFallbackProps {
  url?: string;
  fallback: React.ReactNode;
}

const isImgUrl = async (url?: string) => {
  if (!url) return false;
  const img = new Image();
  img.src = url;
  return new Promise((resolve) => {
    img.onerror = () => resolve(false);
    img.onload = () => resolve(true);
  });
};

export const ImageWithFallback = ({ url, fallback }: ImageWithFallbackProps) => {
  const [isImage, setIsImage] = useState(false);

  useRunOnce(async () => {
    if (url) {
      const res = (await isImgUrl(url)) as boolean;
      setIsImage(res);
    }
  });

  if (isImage) {
    return <img src={url} width="24px" height="24px" />;
  } else {
    return fallback;
  }
};
